import React from 'react';
import ZInput from '../../../z-input';
import ZButton from '../../../z-button';
import styles from './content-photo-preview.module.scss';
import ZDeleteButton from '../../../z-button-delete';
import { ReactComponent as CopySVG } from '../../../../assets/logos/copy.svg';
import { onCopy } from '../../../../utils/window';

const PhotoPreviewView = ({
  style,
  alt,
  title,
  info,
  validUri,
  src,
  fileName,
  placeHolder,
  removePhoto,
  onLoad,
  onChange,
  photoId,
  readOnly,
  showInfo,
  showDelete,
  // New props for button functionality
  canSaveImage,
  buttonText,
  onSaveImage,
}) => {
  return (
    <div className={`${styles['photo-preview']}`} style={style}>
      <div className={`${styles['photo-preview__photo']}`}>
        <img
          alt={alt}
          onLoad={onLoad}
          src={!!info.uri && validUri ? src : placeHolder}
        />
      </div>
      
      <div className={removePhoto ? `${styles['photo-preview__input']}` : `${styles['photo-preview__input']} ${styles['photo-preview__input--hero']}`}>
        <ZInput
          error={!validUri && { message: 'Please use an image from the Photo App.' }}
          label={!!src ? 'Image URL' : 'Paste Image URL'}
          style={{ width: '100%', marginBottom: '0' }}
          className="url-input"
          text={src || ''} 
          onChange={(text) => onChange('uri', text)}
          inputKey={`${photoId}__url`}
          readOnly={readOnly}
        />
        
        <div className={`${styles['photo-preview__meta']}`}>
          <ZInput 
            label='Alt Text'
            text={alt || ''} 
            style={{ width: '100%', marginBottom: '0' }}
            className="meta-input"
            onChange={(text) => onChange('alt', text)}
            inputKey={`${photoId}__alt`}
            placeholder="Describe the image"
          />
          <ZInput 
            label='Title Text' 
            text={title || ''} 
            style={{ width: '100%', marginBottom: '0' }}
            className="meta-input"
            onChange={(text) => onChange('title', text)}
            inputKey={`${photoId}__title`}
            placeholder="Image title (optional)"
          />
        </div>
        
        {/* Action Buttons Section */}
        <div className="action-buttons">
          {/* Save Button Section */}
          {(!readOnly || canSaveImage) && (
            <div className="save-section">
              {canSaveImage && (
                <p className="save-instructions">
                  {buttonText === 'Add Image' 
                    ? 'Click the button below to save.'
                    : 'You have unsaved image changes. Click the button below to save.'
                  }
                </p>
              )}
              <button
                className="save-button"
                disabled={!canSaveImage}
                onClick={onSaveImage}
              >
                {buttonText}
              </button>
            </div>
          )}
          
          {/* Delete Button */}
          {showDelete && (
            <div className="delete-section">
              <button 
                onClick={removePhoto}
              >
                Delete
              </button>
            </div>
          )}
        </div>
        
        {showInfo && 
          <div className={`${styles['info']}`}>
            <p className={`${styles['info__field']}`}>
              {`Date Added: ${info.createdAt || 'N/A'}`}
            </p>
            <p className={`${styles['info__field']}`}>
              {`Dimensions: ${info.height && info.width ? `${info.height} x ${info.width}` : 'N/A'}`}
            </p>
            <p className={`${styles['info__field']}`}>
              Source: 
              <br/>
              {info.sourceUri ? (
                <a href={info.sourceUri} target="_blank" rel="noopener noreferrer">
                  {info.sourceUri}
                </a>
              ) : (
                'N/A'
              )}
            </p>
            {info.sourceType === 'Cloudinary' && fileName && (
              <p className={`${styles['info__copy']}`} onClick={() => onCopy(fileName)}>
                <span>Copy File Name</span>
                <CopySVG/>
              </p>
            )}
          </div>
        }
      </div>
    </div>
  )
}

export default PhotoPreviewView;
